module.exports = __webpack_public_path__ + "static/media/error_illustration.d9cd20e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/error_illustration.svg
// module id = 1243
// module chunks = 0